import styled, { css } from 'styled-components/macro';

import { IWithThemeProps } from 'typings';

export const bubbleStyles = css`
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  left: 50%;
  max-width: 330px;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  z-index: 100;
`;

export const ButtonContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  margin-left: 20px;
`;

export const buttonStyles = css`
  && {
    padding: 15px 20px;
  }
`;

const svgStyles = css`
  ${({ theme }: IWithThemeProps) => `
    [data-svg-class='Stroke'] {
      stroke: ${theme.bottomForegroundActionPrimary};
    }
  `}
`;

export const videoSvgStyles = css`
  ${svgStyles}

  margin: 0 0 1px 2px;
`;

export const photoSvgStyles = css`
  ${svgStyles}

  margin-bottom: 2px;
`;

export const fileSvgStyles = css`
  ${svgStyles}

  margin-left: 3px;
`;
